import React from 'react';

// Kit
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui';

const RankingItem = ({ avatar, name, role, type, question, totalClicks, rank }) => {
    const isAdvisers = type === 'advisers';

    return (
        <div className="flex items-center justify-between gap-3 rounded-sm border border-transparent px-2 py-2 transition-colors duration-150 hover:border-border hover:bg-secondary/60">
            <div className="flex min-w-0 items-center gap-3">
                {
                    isAdvisers ? (
                        <Avatar className="h-10 w-10 shrink-0 ring-2 ring-primary-tint">
                            <AvatarImage src={avatar} alt={name} />
                            <AvatarFallback>{(name || '?').trim().slice(0, 1).toUpperCase()}</AvatarFallback>
                        </Avatar>
                    ) : (
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-tint text-[13px] font-bold tabular text-primary">
                            {rank}
                        </span>
                    )
                }
                <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-foreground">{isAdvisers ? name : question}</p>
                    {isAdvisers && <p className="truncate text-xs text-muted-foreground">{role}</p>}
                </div>
            </div>
            <span className="deck-kpi tabular shrink-0 rounded-sm bg-secondary px-2.5 py-1 text-sm text-foreground">
                {totalClicks}
            </span>
        </div>
    )
}

export default RankingItem;
